import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { NOTIFICACAO_LISTA_CATEGORIAS_SUCESSO, NOTIFICACAO_LISTA_CATEGORIAS, NOTIFICACAO_LISTA_ESCOLAS_SUCESSO, NOTIFICACAO_LISTA_ESCOLAS, INICIA_NOTIFICACAO, SALVA_NOTIFICACAO, ATUALIZA_NOTIFICACAO, BUSCA_NOTIFICACAO_EDICAO, REMOVE_NOTIFICACAO, LISTA_NOTIFICACAO, NOTIFICACAO_LISTA_TURMAS } from "constants/ActionTypes";
import requisicaoApiNotificacao from 'util/ApiNotificacao';
import requisicaoApi from 'util/Api';
import { showAuthMessage } from "actions/Notificacao";
import { listaTurmas, listaTurmasSucesso, listaCategoriasSucesso, salvaNotificacaoSucesso, removeNotificacaoSucesso, inicioNotificacaoSucesso, buscaNotificacaoEdicaoSucesso, listaNotificacaoSucesso, listaEscolasSucesso } from "actions/Notificacao";
import { draftHtmlToPlainText} from 'luxFw/transformations/Common';
/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

const getNotificacaos = async () =>
    await requisicaoApiNotificacao.get(`/v1/notificacoes/templates/${localStorage.getItem('idClienteFixado')}`)
    .then(resposta => resposta)
    .catch(error => error);

const getCategorias = async () =>
    await requisicaoApiNotificacao.get(`/v1/categorias`)
    .then(resposta => resposta)
    .catch(error => error);

const getNotificacaoEdicao = async (id) =>
  await requisicaoApiNotificacao.get(`/v1/notificacoes/templates/notificacao/${id}`)
    .then(resposta => resposta)
    .catch(error => error);

const getListaNotificacao = async (nomeFiltro) =>
  await requisicaoApiNotificacao.get(`/v1/notificacoes/templates/${localStorage.getItem('idClienteFixado')}`)
    .then(resposta => resposta)
    .catch(error => error);

const getEscolas = async () =>
  await requisicaoApi.get('/escolas')
    .then(res => res)
    .catch(err => err);

const getTurmas = async (escolaId) =>
  await requisicaoApi.get(`/turmas?escolaId=${escolaId}`)
    .then(res => res)
    .catch(err => err);

/*#################################################################################################################*/
/* ------------------------------------- Requests do tipo POST, PUT E DELETE --------------------------------------*/


// Suporta tanto JSON quanto FormData. Quando receber FormData, axios define o content-type automaticamente.
const adicionaNotificacaoRequest = async (notificacaoOuFormData) => await requisicaoApiNotificacao.post('/v1/notificacoes', notificacaoOuFormData)
  .then(resposta => resposta)
  .catch(error => error);

const atualizaNotificacaoRequest = async (notificacaoOuFormData) => await requisicaoApiNotificacao.put('/v1/notificacoes', notificacaoOuFormData)
  .then(resposta => resposta)
  .catch(error => error);

const deleteNotificacaoRequest = async (id) =>
  await requisicaoApiNotificacao.delete('/v1/notificacoes/' + id)
    .then(resposta => resposta)
    .catch(error => error);

/*#################################################################################################################*/
/* ------------------------------------------ Funções das Sagas ---------------------------------------------------*/
const getMensagemErro = (ret, fallback) => {
  const status = ret && ret.response && ret.response.status;
  const data = ret && ret.response && ret.response.data;
  
  if (status === 400 || status === 406) {
    const inconsistencias = (data && data.inconsistencias) || [];
    if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
      return inconsistencias[0].mensagem || JSON.stringify(data);
    }
    return (data && (data.mensagem || data.message)) ? (data.mensagem || data.message) : JSON.stringify(data);
  }
  
  if (ret && ret.message) return JSON.stringify(ret.message);
  return fallback || 'Falha na operação.';
};

function* fnIniciaNotificacao() {
  try {
    const retorno = yield call(getNotificacaos);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(inicioNotificacaoSucesso(retorno.data));
    }
  } catch (error) {
    
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnBuscaNotificacaoEdicao({ payload }) {
  try {
    const retorno = yield call(getNotificacaoEdicao, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(buscaNotificacaoEdicaoSucesso(retorno.data));
      const idEscola = retorno.data.idsEscola || retorno.data.IdsEscola;
      if (idEscola.length > 0) 
      {
        for (const element of idEscola) {
          yield put(listaTurmas(element));
        }
      }

      
      // if (idEscola) {
      //   yield put(listaTurmas(idEscola));
      // }      
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaNotificacao({ payload }) {
  try {
    const { nome } = payload;
    const retorno = yield call(getListaNotificacao, nome);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(listaNotificacaoSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaEscolas() {
  try {
    const res = yield call(getEscolas);
    if (res.status === 200) {
      // API pode retornar array ou objeto único dependendo da permissão/contexto
      // Garantir que seja array para o reducer e componente
      let lista = [];
      
      if (Array.isArray(res.data)) {
        lista = res.data;
      } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
        // Alguns endpoints retornam { data: [...], ... }
        lista = res.data.data;
      } else if (res.data && res.data.items && Array.isArray(res.data.items)) {
         // Alguns endpoints paginados retornam items
         lista = res.data.items;
      } else if (res.data && typeof res.data === 'object') {
        // Se retornou um objeto único (não null), transforma em array
        // Cuidado com objetos vazios ou estruturas inesperadas
        const values = Object.values(res.data);
        if (values.length > 0 && typeof values[0] === 'object') {
            // Pode ser um map { "1": {id:1...}, "2": {id:2...} }
             lista = values;
        } else {
             lista = [res.data];
        }
      }

      yield put(listaEscolasSucesso(lista));
    } else {
      yield put(showAuthMessage(getMensagemErro(res, 'Erro ao listar escolas')));
    }
  } catch (error) {
    console.error('SagaCalendario: fnListaEscolas error', error);
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaTurmas({ payload }) {
  try {
    const res = yield call(getTurmas, payload);
    if (res.status === 200) {
      yield put(listaTurmasSucesso(res.data));
    } else {
      yield put(showAuthMessage(getMensagemErro(res, 'Erro ao listar turmas')));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaCategorias() {
  try {
    const res = yield call(getCategorias);
    if (res.status === 200) {
      // API pode retornar array ou objeto único dependendo da permissão/contexto
      // Garantir que seja array para o reducer e componente
      let lista = [];
      
      if (Array.isArray(res.data)) {
        lista = res.data;
      } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
        // Alguns endpoints retornam { data: [...], ... }
        lista = res.data.data;
      } else if (res.data && res.data.items && Array.isArray(res.data.items)) {
         // Alguns endpoints paginados retornam items
         lista = res.data.items;
      } else if (res.data && typeof res.data === 'object') {
        // Se retornou um objeto único (não null), transforma em array
        // Cuidado com objetos vazios ou estruturas inesperadas
        const values = Object.values(res.data);
        if (values.length > 0 && typeof values[0] === 'object') {
            // Pode ser um map { "1": {id:1...}, "2": {id:2...} }
             lista = values;
        } else {
             lista = [res.data];
        }
      }

      yield put(listaCategoriasSucesso(lista));
    } else {
      yield put(showAuthMessage(getMensagemErro(res, 'Erro ao listar escolas')));
    }
  } catch (error) {
    console.error('SagaCalendario: fnListaEscolas error', error);
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnSalvaNotificacao({ payload }) {
  try {
    payload.corpo = draftHtmlToPlainText(payload.corpoHtml)
    const notificacaoEntrada = {
      id: payload.id,
      titulo: payload.titulo,
      subtitulo: payload.subtitulo,
      corpo: draftHtmlToPlainText(payload.corpoHtml),
      corpoHtml: payload.corpoHtml,
      urlImagem: payload.urlImagem,
      idCategoria: payload.idCategoria,
      idCliente: localStorage.getItem('idClienteFixado'),
      idsEscola: payload.idsEscola,
      idsTurma: payload.idsTurma,
      enviarDeImediato: payload.enviarDeImediato,
      dataHoraEnvio: payload.dataHoraEnvio?.format('YYYY-MM-DD'),
      alteraFoto: payload.alteraFoto,
    };
    const request = notificacaoEntrada.id ? atualizaNotificacaoRequest : adicionaNotificacaoRequest;
    const retorno = yield call(request, notificacaoEntrada);
    if (retorno.message) {
      const status = retorno?.response?.status;
      const data = retorno?.response?.data;
      if (status === 400) {
        for(const item in retorno?.response?.data.notifications) {
          yield put(showAuthMessage(retorno?.response?.data.notifications[item].message));
        }
      } else {
        yield put(showAuthMessage(JSON.stringify(retorno.message)));
      }
    } else {
      yield put(salvaNotificacaoSucesso("Cadastro salvo com sucesso!"));
      yield put({ type: LISTA_NOTIFICACAO, payload: { nome: '' } });
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnAtualizaNotificacao({ payload }) {
  try {
    const notificacaoEntrada = payload;
    const isFD = (typeof FormData !== 'undefined') && (notificacaoEntrada instanceof FormData);
    const normalizeId = (v) => {
      if (v === null || typeof v === 'undefined' || v === '') return undefined;
      const n = parseInt(String(v), 10);
      if (isNaN(n) || n <= 0) return undefined;
      return n;
    };
    let notificacao = notificacaoEntrada;
    if (!isFD) {
      const jaTemResp = Array.isArray(notificacaoEntrada.responsaveis);
      const respResp = Array.isArray(notificacaoEntrada.responsaveis) ? notificacaoEntrada.responsaveis.map(it => ({
        IdPessoaResponsavel: normalizeId(it && it.pessoaVinculada),
        TipoParentesco: (it && it.parentesco) || null,
        TipoRelacao: 'RESPONSAVEL',
        CadastroNoApp: !!(it && ((it.CadastroNoApp !== undefined) ? it.CadastroNoApp : it.cadastroNoApp))
      })).filter(x => typeof x.IdPessoaResponsavel !== 'undefined') : [];
      const respAut = Array.isArray(notificacaoEntrada.autorizados) ? notificacaoEntrada.autorizados.map(it => ({
        IdPessoaResponsavel: normalizeId(it && it.pessoaVinculada),
        TipoParentesco: (it && it.parentesco) || null,
        TipoRelacao: 'AUTORIZADO',
        CadastroNoApp: !!(it && ((it.CadastroNoApp !== undefined) ? it.CadastroNoApp : it.cadastroNoApp))
      })).filter(x => typeof x.IdPessoaResponsavel !== 'undefined') : [];
      notificacao = {
        ...notificacaoEntrada,
        responsaveis: jaTemResp ? [...respResp, ...respAut] : [...respResp, ...respAut]
      };
    }
    const retorno = yield call(atualizaNotificacaoRequest, notificacao);
    if (retorno.message) {
      const status = retorno?.response?.status;
      const data = retorno?.response?.data;
      if (status === 400) {
        let mensagemValidacao = '';
        let inconsistencias = data?.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
          // Ex.: [{ propriedade: 'CodigoInep', mensagem: 'Já existe ...' }]
          mensagemValidacao = inconsistencias[0].mensagem;
        } else if (data && typeof data === 'object') {
          mensagemValidacao = data.mensagem || JSON.stringify(data);
        }
        yield put(showAuthMessage(mensagemValidacao || retorno.message));
      } else {
        yield put(showAuthMessage(JSON.stringify(retorno.message)));
      }
    } else {
      yield put(salvaNotificacaoSucesso("Cadastro atualizado com sucesso!"));
      yield put({ type: LISTA_NOTIFICACAO, payload: { nome: '' } });
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnRemoveNotificacao({ payload }) {
  try {
    const retorno = yield call(deleteNotificacaoRequest, payload);
    
    // Verifica se houve erro de validação (status 400 ou sucesso: false)
    const data = retorno?.response?.data || retorno?.data;
    
    // Tratamento para quando a API retorna erro 400 com inconsistências
    if (retorno?.response?.status === 400 || (data && data.sucesso === false)) {
        let mensagemErro = '';
        if (Array.isArray(data?.inconsistencias) && data.inconsistencias.length > 0) {
            mensagemErro = data.inconsistencias[0].mensagem;
        } else if (Array.isArray(data?.erros) && data.erros.length > 0) {
            mensagemErro = data.erros[0].mensagem;
        } else {
            mensagemErro = data?.mensagem || 'Erro ao excluir notificacao.';
        }
        yield put(showAuthMessage(mensagemErro));
        return;
    }

    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(removeNotificacaoSucesso("Removido com sucesso!"));
      yield put({ type: LISTA_NOTIFICACAO, payload: { nome: '' } });
    }
  } catch (error) {
    // Tenta extrair mensagem amigável de erro se disponível
    const msg = error?.response?.data?.mensagem || 
                (error?.response?.data?.inconsistencias?.[0]?.mensagem) || 
                JSON.stringify(error);
    yield put(showAuthMessage(msg));
  }
}

export function* watchListaEscolas() {
  yield takeEvery(NOTIFICACAO_LISTA_ESCOLAS, fnListaEscolas);
}

export function* watchListaCategorias() {
  yield takeEvery(NOTIFICACAO_LISTA_CATEGORIAS, fnListaCategorias);
}

export function* watchListaTurmas() {
  yield takeEvery(NOTIFICACAO_LISTA_TURMAS, fnListaTurmas);
}

/*#################################################################################################################*/
/* -------------------------------------- Exportação das Sagas ----------------------------------------------------*/

export function* iniciaAcoesNotificacao() {
  yield takeEvery(INICIA_NOTIFICACAO, fnIniciaNotificacao);
}

export function* salvaNotificacao() {
  yield takeEvery(SALVA_NOTIFICACAO, fnSalvaNotificacao);
}

export function* atualizaNotificacao() {
  yield takeEvery(ATUALIZA_NOTIFICACAO, fnAtualizaNotificacao);
}

export function* buscaNotificacaoEdicao() {
  yield takeEvery(BUSCA_NOTIFICACAO_EDICAO, fnBuscaNotificacaoEdicao);
}

export function* removeNotificacao() {
  yield takeEvery(REMOVE_NOTIFICACAO, fnRemoveNotificacao);
}

export function* listaNotificacao() {
  yield takeEvery(LISTA_NOTIFICACAO, fnListaNotificacao);
}

export default function* rootSaga() {
  yield all([
    fork(iniciaAcoesNotificacao),
    fork(salvaNotificacao),
    fork(atualizaNotificacao),
    fork(buscaNotificacaoEdicao),
    fork(removeNotificacao),
    fork(listaNotificacao),
    fork(watchListaEscolas),
    fork(watchListaCategorias),
    fork(watchListaTurmas),
  ]);
}
